<ng-container *ngIf="isLoggedIn$ | async; else loginView">
  <app-layout></app-layout>
</ng-container>
<ng-template #loginView>
  <router-outlet></router-outlet>
</ng-template>